import React, {useState, useRef, useCallback} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardMedia,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Box,
  Tabs,
  Tab,
  TextField,
  Select,
  MenuItem,
  IconButton,
  DialogActions,
  FormHelperText
} from '@mui/material';
import {Rnd} from 'react-rnd';
import {Stage, Layer, Image as KonvaImage} from 'react-konva';
import DeleteIcon from '@mui/icons-material/Delete';
import template1 from './Certificate/Template1.png';
import template2 from './Certificate/Template2.png';
import template3 from './Certificate/Template3.png';
import template4 from './Certificate/Template4.jpeg';
import template5 from './Certificate/Template5.png';
import template6 from './Certificate/Template6.png';
import template7 from './Certificate/Template7.png';
import template8 from './Certificate/Template8.png';
import template10 from './Certificate/Template10.jpg';
import template11 from './Certificate/Template11.png';
import Upload from 'src/minimal-components/upload/upload';
// import {callback} from 'chart.js/dist/helpers/helpers.core';
interface CustomFile extends File {
  path?: string;
  preview?: string;
  lastModifiedDate?: Date;
}
type CanvasElement = {
  type: 'heading' | 'paragraph' | 'field';
  label: string;
};
interface Template {
  id: number;
  name: string;
  src: string;
}

interface DraggableField {
  id: number;
  label: string;
  type: 'heading' | 'paragraph' | 'field';
  text: string;
  position: {x: number; y: number};
  size: {width: number; height: number};
  fontSize: number;
  fontFamily: string;
  color: string;
  backgroundColor: string;
  display: boolean;
}

interface CanvasItem {
  id: number;
  type: 'heading' | 'paragraph' | 'field';
  label: string;
  text: string;
  fontSize: number;
  fontFamily: string;
  color: string;
  position: {x: number; y: number};
  size: {width: number; height: number};
}
interface DraggableImage {
  id: number;
  src: string;
  position: {x: number; y: number};
  size: {width: number; height: number};
}

function TemplateStepperDialog() {
  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState<Template>({
    id: 4,
    name: 'Template 4',
    src: template1
  });
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [draggableFields, setDraggableFields] = useState<DraggableField[]>([]);
  const [selectedField, setSelectedField] = useState<DraggableField | null>(
    null
  );
  const [draggableImages, setDraggableImages] = useState<DraggableImage[]>([]);
  const [images, setImages] = useState<File[]>([]);
  const [selectedImage, setSelectedImage] = useState<DraggableImage | null>(
    null
  );
  const [canvasItems, setCanvasItems] = useState<CanvasItem[]>([]);
  const [selectedItem, setSelectedItem] = useState<CanvasItem | null>(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [imagePreviews, setImagePreviews] = useState<string[]>([]);
  const certificateRef = useRef<any>(null);

  const templates = [
    {id: 4, name: 'Template 4', src: template1},
    {id: 5, name: 'Template 5', src: template2},
    {id: 6, name: 'Template 6', src: template3},
    {id: 7, name: 'Template 7', src: template4},
    {id: 8, name: 'Template 8', src: template5},
    {id: 9, name: 'Template 9', src: template6},
    {id: 10, name: 'Template 10', src: template7},
    {id: 11, name: 'Template 11', src: template8},
    {id: 1, name: 'Template 1', src: template10},
    {id: 2, name: 'Template 2', src: template11}
  ];
  const elements: CanvasElement[] = [
    {type: 'heading', label: 'Header'},
    {type: 'paragraph', label: 'Text'},
    {type: 'field', label: 'Field'}
  ];

  const fields = [
    {label: 'User Name'},
    {label: 'Course Name'},
    {label: 'Completion Date'}
  ];
  const steps = ['Select Template', 'Customize', 'Preview'];
  const addCanvasItem = (
    type: 'heading' | 'paragraph' | 'field',
    label: string,
    display: boolean
  ) => {
    const newItem = {
      id: Date.now(),
      type,
      label,
      text: label,
      fontSize: type === 'heading' ? 24 : 16,
      fontFamily: 'Arial',
      color: '#000',
      position: {x: 100, y: 100},
      size: {width: 150, height: 50},
      backgroundColor: '#ffffff',
      display
    };
    setDraggableFields([...draggableFields, newItem]);
    setSelectedField(newItem);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleNext = () => setActiveStep(prev => prev + 1);
  const handleBack = () => setActiveStep(prev => prev - 1);

  const selectTemplate = (template: Template) => {
    setSelectedTemplate(template);
    const img = new window.Image();
    img.src = template.src;
    img.onload = () => {
      setImage(img);
    };
    handleNext();
  };

  // const addTextField = () => {
  //   const newField: DraggableField = {
  //     id: Date.now(),
  //     label: 'New Text',
  //     text: 'New Text',
  //     position: {x: 100, y: 100},
  //     size: {width: 150, height: 40},
  //     fontSize: 16,
  //     fontFamily: 'Arial',
  //     color: '#000',
  //     backgroundColor: '#ffffff'
  //   };
  //   setDraggableFields(prevFields => [...prevFields, newField]);
  //   setSelectedField(newField);
  // };

  const handleDrag = (e: any, data: any, id: number) => {
    setDraggableFields(prevFields =>
      prevFields.map(field =>
        field.id === id ? {...field, position: {x: data.x, y: data.y}} : field
      )
    );
  };

  const openImageDialog = () => {
    setImageDialogOpen(true);
  };

  const closeImageDialog = () => {
    setImageDialogOpen(false);
    setImagePreviews([]);
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const previewUrls: string[] = [];
      Array.from(files).forEach(file => {
        const reader = new FileReader();
        reader.onload = e => {
          if (e.target?.result) {
            previewUrls.push(e.target.result as string);
            setImagePreviews([...previewUrls]);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const addImageFromPreview = (src: string) => {
    const newImage: DraggableImage = {
      id: Date.now(),
      src,
      position: {x: 100, y: 100},
      size: {width: 200, height: 150}
    };
    setDraggableImages(prevImages => [...prevImages, newImage]);
    closeImageDialog();
  };

  const handleImageDrag = (e: any, data: any, id: number) => {
    setDraggableImages(prevImages =>
      prevImages.map(img =>
        img.id === id ? {...img, position: {x: data.x, y: data.y}} : img
      )
    );
  };

  const handleImageResize = (
    e: any,
    direction: any,
    ref: any,
    delta: any,
    id: number
  ) => {
    setDraggableImages(prevImages =>
      prevImages.map(img =>
        img.id === id
          ? {
              ...img,
              size: {
                width: parseInt(ref.style.width),
                height: parseInt(ref.style.height)
              }
            }
          : img
      )
    );
  };
  const handleDrop = useCallback((acceptedFiles: File[]) => {
    // Map accepted files to DraggableImage format
    const newImages = acceptedFiles.map(file => ({
      id: Date.now() + Math.random(), // Unique ID
      src: URL.createObjectURL(file), // Create a preview URL for the image source
      position: {x: 100, y: 100},
      size: {width: 200, height: 150}
    }));

    // Add new images to draggableImages state
    setDraggableImages(prevImages => [...prevImages, ...newImages]);

    // Map accepted files to include preview URLs and update images state
    const newFiles = acceptedFiles.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file)
      })
    );
    // Update images state with the new files
    setImages(prevFiles => [...prevFiles, ...newFiles]);
  }, []);

  const handleRemoveFile = useCallback(
    (inputFile: File | string) => {
      // Remove file from images array
      const filteredImages = images.filter(file => file !== inputFile);

      // Update images state
      setImages(filteredImages);

      // Remove the corresponding image from draggableImages if it exists
      setDraggableImages(prevImages =>
        prevImages.filter(
          img =>
            img.src !==
            (typeof inputFile === 'string'
              ? inputFile
              : URL.createObjectURL(inputFile))
        )
      );
    },
    [images]
  );
  // const handleSelected = callback(
  //   (inputFile: File | string) => {
  //     // Remove file from images array
  //     console.log('inputFiles' + inputFile);
  //   },
  //   [images]
  // );
  const handleDeleteImage = (id: number) => {
    setDraggableImages(prevImages => prevImages.filter(img => img.id !== id));
    setSelectedImage(null);
  };
  const handleRemoveAllFiles = useCallback(() => {
    // Clear images and draggableImages states
    setImages([]);
    setDraggableImages([]);
  }, []);

  const handleResize = (
    e: any,
    direction: any,
    ref: any,
    delta: any,
    id: number
  ) => {
    setDraggableFields((prevFields: DraggableField[]) =>
      prevFields.map(field =>
        field.id === id
          ? {
              ...field,
              size: {
                width: parseInt(ref.style.width, 10),
                height: parseInt(ref.style.height, 10)
              }
            }
          : field
      )
    );
  };

  const handleDeleteField = (id: number) => {
    setDraggableFields((prevFields: any[]) =>
      prevFields.filter((field: {id: number}) => field.id !== id)
    );
    setSelectedField(null);
  };

  const updateField = (key: keyof DraggableField, value: any) => {
    if (selectedField) {
      setDraggableFields((prevFields: DraggableField[]) =>
        prevFields.map(field =>
          field.id === selectedField.id
            ? {
                ...field,
                [key]: value // Dynamically update the field
              }
            : field
        )
      );
      setSelectedField({
        ...selectedField,
        [key]: value
      });
    }
  };
  // const updateSelectedItem = (key: keyof CanvasItem, value: any) => {
  //   if (selectedItem) {
  //     setCanvasItems((items: any[]) =>
  //       items.map((item: {id: any}) =>
  //         item.id === selectedItem.id ? {...item, [key]: value} : item
  //       )
  //     );
  //     setSelectedItem({...selectedItem, [key]: value});
  //   }
  // };

  // const deleteSelectedItem = () => {
  //   if (selectedItem) {
  //     setCanvasItems((items: any[]) =>
  //       items.filter((item: {id: any}) => item.id !== selectedItem.id)
  //     );
  //     setSelectedItem(null);
  //   }
  // };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Open Template Wizard
      </Button>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <DialogTitle>{steps[activeStep]}</DialogTitle>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <DialogContent>
          {activeStep === 0 && (
            <Grid container spacing={3}>
              {templates.map(template => (
                <Grid item xs={4} key={template.id}>
                  <Card onClick={() => selectTemplate(template)}>
                    <CardMedia
                      component="img"
                      image={template.src}
                      alt={template.name}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          {activeStep === 1 && (
            <Box display="flex">
              <Box width={240} bgcolor="#2E3B55" color="white" p={2}>
                <Tabs
                  value={selectedTab}
                  onChange={(e, newValue) => setSelectedTab(newValue)}>
                  <Tab label="Elements" />
                  <Tab label="Fields" />
                </Tabs>

                <Box mt={2}>
                  {selectedTab === 0 &&
                    elements.map(element => (
                      <Button
                        key={element.label}
                        fullWidth
                        variant="outlined"
                        sx={{color: '#ddd', mb: 1}}
                        onClick={() =>
                          addCanvasItem(element.type, element.label, true)
                        }>
                        {element.label}
                      </Button>
                    ))}

                  {selectedTab === 1 &&
                    fields.map(field => (
                      <Button
                        key={field.label}
                        fullWidth
                        variant="outlined"
                        sx={{color: '#ddd', mb: 1}}
                        onClick={() =>
                          addCanvasItem('field', field.label, false)
                        }>
                        {field.label}
                      </Button>
                    ))}
                  {selectedTab == 0 && (
                    <Button
                      variant="outlined"
                      fullWidth
                      onClick={openImageDialog}
                      sx={{color: '#ddd', mb: 2}}>
                      Upload Image
                    </Button>
                  )}
                </Box>
              </Box>

              <Box flexGrow={1} position="relative" border="1px solid #ddd">
                <Stage width={800} height={600} ref={certificateRef}>
                  <Layer>
                    {image && (
                      <KonvaImage image={image} width={800} height={600} />
                    )}
                  </Layer>
                </Stage>
                {draggableFields.map(field => (
                  <Rnd
                    key={field.id}
                    position={{
                      x: field.position.x * zoomLevel,
                      y: field.position.y * zoomLevel
                    }}
                    size={{
                      width: field.size.width * zoomLevel,
                      height: field.size.height * zoomLevel
                    }}
                    onDragStop={(e, data) => handleDrag(e, data, field.id)}
                    onResizeStop={(e, direction, ref, delta) =>
                      handleResize(e, direction, ref, delta, field.id)
                    }
                    onClick={() => setSelectedField(field)}
                    bounds="parent">
                    <Box
                      sx={{
                        backgroundColor: field.backgroundColor,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border:
                          selectedField?.id === field.id
                            ? '1px solid blue'
                            : 'none',
                        cursor: 'pointer',
                        padding: 1
                      }}>
                      <Typography
                        style={{
                          fontSize: `${field.fontSize} !important`,
                          fontFamily: field.fontFamily,
                          color: field.color,
                          textAlign: 'center'
                        }}>
                        {field.text}
                      </Typography>
                    </Box>
                    <Button
                      onClick={() => handleDeleteField(field.id)}
                      sx={{
                        position: 'absolute',
                        top: -8,
                        right: -8,
                        color: 'red',
                        minWidth: '24px',
                        height: '24px',
                        padding: 0,
                        fontSize: '12px',
                        fontWeight: 'bold',
                        borderRadius: '50%',
                        backgroundColor: '#fff'
                      }}>
                      &times;
                    </Button>
                  </Rnd>
                ))}
                {draggableImages.map(img => (
                  <Rnd
                    key={img.id}
                    position={img.position}
                    size={{width: img.size.width, height: img.size.height}}
                    onDragStop={(e, data) => handleImageDrag(e, data, img.id)}
                    onResizeStop={(e, direction, ref, delta) =>
                      handleImageResize(e, direction, ref, delta, img.id)
                    }
                    onClick={() => setSelectedImage(img)}
                    bounds="parent">
                    <img
                      src={img.src}
                      alt="User Uploaded"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <IconButton
                      onClick={() => handleDeleteImage(img.id)}
                      sx={{
                        position: 'absolute',
                        top: -10,
                        right: -10,
                        color: 'red',
                        backgroundColor: '#fff',
                        borderRadius: '50%'
                      }}>
                      <DeleteIcon />
                    </IconButton>
                  </Rnd>
                ))}
              </Box>

              {selectedField && selectedField.display && (
                <Box p={2} width={300} border="1px solid #ddd" ml={2}>
                  <Typography variant="h6">Edit Text Field</Typography>
                  <TextField
                    label="Text"
                    fullWidth
                    name="Text"
                    value={selectedField.text}
                    onChange={e => updateField('text', e.target.value)}
                  />
                  <TextField
                    label="Font Size"
                    fullWidth
                    type="number"
                    value={selectedField.fontSize}
                    onChange={e =>
                      updateField('fontSize', Number(e.target.value))
                    }
                  />
                  <Select
                    label="Font Family"
                    fullWidth
                    value={selectedField.fontFamily}
                    onChange={e => updateField('fontFamily', e.target.value)}>
                    <MenuItem value="Arial">Arial</MenuItem>
                    <MenuItem value="Courier New">Courier New</MenuItem>
                    <MenuItem value="Georgia">Georgia</MenuItem>
                  </Select>
                  <TextField
                    label="Font Color"
                    fullWidth
                    type="color"
                    value={selectedField.color}
                    onChange={e => updateField('color', e.target.value)}
                  />
                  <TextField
                    label="Background Color"
                    fullWidth
                    type="color"
                    value={selectedField.backgroundColor}
                    onChange={e =>
                      updateField('backgroundColor', e.target.value)
                    }
                  />
                </Box>
              )}
            </Box>
          )}

          {activeStep === 2 && (
            <Box
              flexGrow={1}
              position="relative"
              border="1px solid #ddd"
              style={{margin: '0 19vh'}}>
              <Stage width={800} height={600} ref={certificateRef}>
                <Layer>
                  {image && (
                    <KonvaImage image={image} width={800} height={600} />
                  )}
                </Layer>
              </Stage>
              {draggableFields.map(field => (
                <Rnd
                  disableDragging={true}
                  enableResizing={{
                    top: false,
                    right: false,
                    bottom: false,
                    left: false,
                    topRight: false,
                    bottomRight: false,
                    bottomLeft: false,
                    topLeft: false
                  }}
                  key={field.id}
                  position={{
                    x: field.position.x * zoomLevel,
                    y: field.position.y * zoomLevel
                  }}
                  size={{
                    width: field.size.width * zoomLevel,
                    height: field.size.height * zoomLevel
                  }}
                  bounds="parent">
                  <Box
                    sx={{
                      backgroundColor: field.backgroundColor,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border:
                        selectedField?.id === field.id
                          ? '1px solid blue'
                          : 'none',
                      cursor: 'pointer',
                      padding: 1
                    }}>
                    <Typography
                      style={{
                        fontSize: `${field.fontSize} !important`,
                        fontFamily: field.fontFamily,
                        color: field.color,
                        textAlign: 'center'
                      }}>
                      {field.text}
                    </Typography>
                  </Box>
                </Rnd>
              ))}
              {draggableImages.map(img => (
                <Box
                  key={img.id}
                  position="absolute"
                  top={`${img.position.y}px`}
                  left={`${img.position.x}px`}
                  style={{
                    width: img.size.width,
                    height: img.size.height,
                    backgroundImage: `url(${img.src})`,
                    backgroundSize: 'cover'
                  }}
                />
              ))}
            </Box>
          )}
        </DialogContent>

        <Box display="flex" justifyContent="space-between" p={2}>
          <Button disabled={activeStep === 0} onClick={handleBack}>
            Back
          </Button>
          {activeStep < steps.length - 1 && (
            <Button variant="contained" onClick={handleNext}>
              {activeStep === steps.length - 2 ? 'Preview' : 'Next'}
            </Button>
          )}
        </Box>
      </Dialog>
      <Dialog
        open={imageDialogOpen}
        onClose={closeImageDialog}
        fullWidth
        maxWidth="md">
        <DialogTitle>Select an Image</DialogTitle>
        <DialogContent>
          <Upload
            multiple
            thumbnail
            // name="images"
            files={images}
            maxSize={3145728}
            onDrop={handleDrop}
            onRemove={handleRemoveFile}
            onRemoveAll={handleRemoveAllFiles}
            // onSelected={handleSelected}
            onUpload={() => console.info('ON UPLOAD')}
          />
          <Grid container spacing={2} mt={2}>
            {draggableImages.map((images, index) => (
              <Grid item xs={4} key={index}>
                <Card
                  onClick={() => addImageFromPreview(images.src)}
                  sx={{cursor: 'pointer'}}>
                  <CardMedia component="img" image={images.src} alt="Preview" />
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeImageDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default TemplateStepperDialog;
